import { connect } from 'react-redux';
import type { Observable } from 'rxjs';
import { fromSecondaryOrderBlotter } from 'state/selectors';
import type { AppState } from 'state/state.model';

import type { StringFileResponse } from '../../../../models/FileResponse';

export interface OwnProps {
  fetchCsv: () => Observable<StringFileResponse>;
}

export interface StateProps {
  error: boolean;
  isLoading: boolean;
}
export const mapStateToProps = (state: AppState): StateProps => {
  const isLoading = fromSecondaryOrderBlotter.isLoading(state);
  const error = fromSecondaryOrderBlotter.isInError(state);
  return {
    error,
    isLoading,
  };
};

export const connectSecondaryMarketOrderBlotterFilter = connect(mapStateToProps);
